import React, { useEffect, useState } from "react";
import { fetchSkills } from "../services/skillService"; // スキルを取得するサービス関数

function SkillList({ userId }) {
  const [skills, setSkills] = useState([]);
  const [loading, setLoading] = useState(true);  // ローディング状態の追加
  const [error, setError] = useState(null);  // エラーメッセージの状態

  useEffect(() => {
    console.log("SkillList is rendered");  // コンポーネントがレンダリングされたことを確認
    if (userId) {
      const loadSkills = async () => {
        console.log("Fetching skills for userId:", userId);  // userIdを確認
        try {
          const userSkills = await fetchSkills(userId);  // スキルの取得
          console.log("Fetched skills:", userSkills);  // 取得したスキルをログに出力
          setSkills(userSkills);  // スキルデータをステートにセット
        } catch (error) {
          console.error("スキルの取得に失敗しました:", error);
          setError("スキルの取得に失敗しました");  // エラーメッセージをセット
        } finally {
          setLoading(false);  // ローディング状態を終了
        }
      };
      loadSkills();
    } else {
      setLoading(false);  // userIdがない場合でもローディングを終了
    }
  }, [userId]);  // userIdが変わるたびに実行

  return (
    <div className="max-w-4xl mx-auto p-6 bg-white shadow-lg rounded-lg">
      <h2 className="text-2xl font-semibold text-gray-800 mb-4">ユーザーのスキル一覧</h2>
      {loading ? (
        <p className="text-lg text-blue-500">スキルを読み込んでいます...</p>  // ローディング状態
      ) : error ? (
        <p className="text-lg text-red-500">{error}</p>  // エラーメッセージ表示
      ) : skills.length > 0 ? (
        <ul className="list-disc pl-6">
          {skills.map((skill) => (
            <li key={skill.id} className="mb-2 text-lg text-gray-700">
              <strong className="text-blue-600">{skill.name}</strong> - {skill.level}
            </li>
          ))}
        </ul>
      ) : (
        <p className="text-lg text-gray-500">まだスキルが登録されていません。</p>
      )}
    </div>
  );
}

export default SkillList;
